import { OidcConfiguration } from '@sonar-software/sonar-security';
import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostOidcConfigurationByCustomerRequest = {
	configuration: OidcConfiguration;
	customerId?: number;
	shardName?: string;
};

export const postOidcConfigurationByCustomer = createPostEndpoint<PostOidcConfigurationByCustomerRequest, void>(
	(request) => `/api/v3/security/oidc/by-customer/${request?.customerId ?? 'current'}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		requestTransform: (request) => request.configuration,
		skipAuthRefresh: true
	}
);
